// extracted by mini-css-extract-plugin
export default {"footerButtonContainer":"footerButtonContainer__3xHP0"};
    if(module.hot) {
      // 1788784374245
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  